module.exports = __webpack_public_path__ + "img/ppt.318bbb66.svg";